// Offers Summary KPIs (top KPI row + prior-period deltas)
export const FETCH_OFFERS_SUMMARY_REQUEST = 'reports/offersReport/FETCH_OFFERS_SUMMARY_REQUEST';
export const FETCH_OFFERS_SUMMARY_SUCCESS = 'reports/offersReport/FETCH_OFFERS_SUMMARY_SUCCESS';
export const FETCH_OFFERS_SUMMARY_FAILURE = 'reports/offersReport/FETCH_OFFERS_SUMMARY_FAILURE';

// KPI Comparison (top-row deltas + AOV value/delta — /sales/offers/kpi-comparison)
export const FETCH_OFFER_KPI_COMPARISON_REQUEST = 'reports/offersReport/FETCH_OFFER_KPI_COMPARISON_REQUEST';
export const FETCH_OFFER_KPI_COMPARISON_SUCCESS = 'reports/offersReport/FETCH_OFFER_KPI_COMPARISON_SUCCESS';
export const FETCH_OFFER_KPI_COMPARISON_FAILURE = 'reports/offersReport/FETCH_OFFER_KPI_COMPARISON_FAILURE';

// Top Offers (Top Offers table — server-paginated, /sales/offers/top-offers)
export const FETCH_TOP_OFFERS_REQUEST = 'reports/offersReport/FETCH_TOP_OFFERS_REQUEST';
export const FETCH_TOP_OFFERS_SUCCESS = 'reports/offersReport/FETCH_TOP_OFFERS_SUCCESS';
export const FETCH_TOP_OFFERS_FAILURE = 'reports/offersReport/FETCH_TOP_OFFERS_FAILURE';

// Offers KPI row (Active Offers + Top Offer tiles) — same /sales/offers/top-offers
// endpoint, but deliberately a SEPARATE call that is scoped only by location +
// date. The table's own call carries search/status/sort/page, so if the KPIs read
// its slice they would re-compute whenever the user filtered the table.
export const FETCH_OFFERS_KPI_REQUEST = 'reports/offersReport/FETCH_OFFERS_KPI_REQUEST';
export const FETCH_OFFERS_KPI_SUCCESS = 'reports/offersReport/FETCH_OFFERS_KPI_SUCCESS';
export const FETCH_OFFERS_KPI_FAILURE = 'reports/offersReport/FETCH_OFFERS_KPI_FAILURE';

// Redemption Trend drill (daily redemptions + order-type breakdown)
export const FETCH_OFFER_REDEMPTION_TREND_REQUEST = 'reports/offersReport/FETCH_OFFER_REDEMPTION_TREND_REQUEST';
export const FETCH_OFFER_REDEMPTION_TREND_SUCCESS = 'reports/offersReport/FETCH_OFFER_REDEMPTION_TREND_SUCCESS';
export const FETCH_OFFER_REDEMPTION_TREND_FAILURE = 'reports/offersReport/FETCH_OFFER_REDEMPTION_TREND_FAILURE';

// Discount Breakdown drill (cost by mechanic/type)
export const FETCH_OFFER_DISCOUNT_BREAKDOWN_REQUEST = 'reports/offersReport/FETCH_OFFER_DISCOUNT_BREAKDOWN_REQUEST';
export const FETCH_OFFER_DISCOUNT_BREAKDOWN_SUCCESS = 'reports/offersReport/FETCH_OFFER_DISCOUNT_BREAKDOWN_SUCCESS';
export const FETCH_OFFER_DISCOUNT_BREAKDOWN_FAILURE = 'reports/offersReport/FETCH_OFFER_DISCOUNT_BREAKDOWN_FAILURE';

// Discount by Type (main report donut — /sales/offers/discount-by-type)
export const FETCH_OFFER_DISCOUNT_BY_TYPE_REQUEST = 'reports/offersReport/FETCH_OFFER_DISCOUNT_BY_TYPE_REQUEST';
export const FETCH_OFFER_DISCOUNT_BY_TYPE_SUCCESS = 'reports/offersReport/FETCH_OFFER_DISCOUNT_BY_TYPE_SUCCESS';
export const FETCH_OFFER_DISCOUNT_BY_TYPE_FAILURE = 'reports/offersReport/FETCH_OFFER_DISCOUNT_BY_TYPE_FAILURE';

// Individual Offer drill (offer detail + top items + promo codes)
export const FETCH_OFFER_DETAIL_REQUEST = 'reports/offersReport/FETCH_OFFER_DETAIL_REQUEST';
export const FETCH_OFFER_DETAIL_SUCCESS = 'reports/offersReport/FETCH_OFFER_DETAIL_SUCCESS';
export const FETCH_OFFER_DETAIL_FAILURE = 'reports/offersReport/FETCH_OFFER_DETAIL_FAILURE';
export const CLEAR_OFFER_DETAIL = 'reports/offersReport/CLEAR_OFFER_DETAIL';
